/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { saveAs } from "file-saver";
import { message, Modal } from "antd";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import { getExportToXLSRoute } from "../../lib/routes/xls-generator";

const initialState = {
  exportToXLSLoading: rtkRequestStatusCodes.idle,
};

const exportToXLS = createAsyncThunk("exportToXLS/exportToXLS", async (exportData) => {
  const url = getExportToXLSRoute();
  try {
    message.loading("Выгрузка файла...", 0);
    const { data } = await axios.post(url, exportData, {
      responseType: "blob",
    });
    message.destroy();
    message.success("Файл загружен");
    saveAs(data, `${exportData.fileName}.xlsx`);
  } catch (error) {
    message.destroy();
    Modal.error({
      title: "Ошибка",
      content: "Ошибка выгрузки XLS",
    });
  }
});

const slice = createSlice({
  name: "exportToXLS",
  initialState,
  reducers: {},
  extraReducers: {
    [exportToXLS.pending]: (state) => {
      state.exportToXLSLoading = rtkRequestStatusCodes.pending;
    },
    [exportToXLS.fulfilled]: (state) => {
      state.exportToXLSLoading = rtkRequestStatusCodes.fulfilled;
    },
    [exportToXLS.rejected]: (state) => {
      state.exportToXLSLoading = rtkRequestStatusCodes.rejected;
    },
  },
});

const { reducer } = slice;

export { exportToXLS };

export default reducer;
